<template>
  <div class="grid px-7 mt-3">
    <div class="col-12 md:col-4 lg:col-3" v-if="robadosListFormatted.length">
      <Listbox 
        v-model="dataArrId"  
        v-if="robadosListFormatted.length"
        :options="robadosListFormatted" 
        dataKey="arrId" 
        optionValue="arrId" 
        optionLabel="name"
        class="shadow-4 border-none"
        >
        <template #option="slotProps">
          <div class="flex justify-content-between" >
            <span class="mt-2">{{getSubcategoriaName(slotProps.option.doc.SubcategoriaID)}}</span>
          </div>
        </template>
      </Listbox>
    </div>
    <div v-if="!robadosListFormatted.length" class="col-12 grid shadow-4 ml-1 justify-content-center"> 
      <label class="text-xl">No hay Efectos registrados</label>
    </div>
    <div v-else-if="Object.keys(efectoData).length" class="col-12 md:col-8 lg:col-9 grid shadow-4 ml-1">
      <div class="flex flex-column gap-2 col-12">
        <label for="categoria">Tipo del Efecto</label>
        <InputText
          v-model="efectoData.Tipoefecto"
          class="lg:col-5 md:col-7 sm:col-12"
          disabled
        />
      </div>
      <div class="col-12 grid align-items-center" >
        <div class="flex flex-column gap-2 col-6">
          <label for="categoria">Categoría</label>
          <InputText
            id="categoria"
            v-model="dataCategoria"
            disabled
          />
        </div>
        <div class="flex flex-column gap-2 col-6">
          <label for="subcategoria">Sub-Categoría</label>
          <InputText
            id="subcategoria"
            v-model="dataSubCategoria"
            disabled
          />
        </div>
      </div>
      <div class="col-12 grid align-items-center">
        <div class="flex flex-column gap-2 col-4">
          <label for="tipo">Tipo (Sub-Categoría)</label>
          <InputText
            id="tipo"
            v-model="dataTipo"
            disabled
          />
        </div>
        <div class="flex flex-column gap-2 col-4">
          <label for="marca">Marca</label>
          <InputText
            id="marca"
            v-model="dataMarca"
            disabled
          />
        </div>
        <div class="flex flex-column gap-2 col-4">
          <label for="modelo">Modelo</label>
          <InputText
            id="modelo"
            v-model="dataModelo"
            disabled
          />
        </div>
      </div>
      <div class="col-12 grid align-items-center">
        <div class="flex flex-column gap-2 col-3">
          <label for="año">Año</label>
          <InputText
            id="año"
            v-model="efectoData.Anio"
            disabled
          />
        </div>
        <div class="flex flex-column gap-2 col-3">
          <label for="nroChasis">N° Chasis</label>
          <InputText
            id="nroChasis"
            v-model="efectoData.Chasis"
            disabled
          />
        </div>
        <div class="flex flex-column gap-2 col-3">
          <label for="nroMotor">N° Motor</label>
          <InputText
            id="nroMotor"
            v-model="efectoData.NumeroMotor"
            disabled
          />
        </div>
        <div class="flex flex-column gap-2 col-3">
          <label for="dominio">Dominio</label>
          <InputText
            id="dominio"
            v-model="efectoData.Dominio"
            disabled
          />
        </div>
      </div>
      <div class="col-12 grid align-items-center">
        <div class="flex flex-column gap-2 col-3">
          <label for="nroSerie">N° Serie</label>
          <InputText
            id="nroSerie"
            v-model="efectoData.NumeroSerie"
            disabled
          />
        </div>
        <div class="flex flex-column gap-2 col-3">
          <label for="imei">N° IMEI</label>
          <InputText
            id="imei"
            v-model="efectoData.Imei"
            disabled
          />
        </div>
        <div class="flex flex-column gap-2 col-3">
          <label for="abonado">N° Abonado</label>
          <InputText
            id="abonado"
            v-model="efectoData.Abonado"
            disabled
          />
        </div>
        <div class="flex flex-column gap-2 col-3">
          <label for="color">Color</label>
          <InputText
            id="color"
            v-model="efectoData.Color"
            disabled
          />
        </div>
      </div>
    </div>
    <div v-else-if="!robadosListFormatted.length" class="col-12 md:col-8 lg:col-9 grid shadow-4 ml-1 justify-content-center"> 
      <label class="text-xl">No hay Efecto/s Cargados</label>
    </div>
    <div v-else class="col-12 md:col-8 lg:col-9 grid shadow-4 ml-1 justify-content-center"> 
      <label class="text-xl">Seleccione un Efecto</label>
    </div>
  </div>
</template>

<script>
import InputText from 'primevue/inputtext/InputText';
import FormObjetos from '../../../components/forms/FormObjetos.vue'
import Listbox from 'primevue/listbox';
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'EfectosForm',
  components: {
    FormObjetos, Listbox
  },
  props: {
    formType: String, 
    viewData: {
      type: Object 
    },
    actuacionType: String, 
  },
  data() {
    return {
      arrId: this.aid || null,
      efectoData:{},
    }
  },
  mounted() {},
  created(){
    this.$store.dispatch("siis/setJuzgados");
    this.$store.dispatch("siis/setMarca"),
    this.$store.dispatch("siis/setModelo");
    this.$store.dispatch("siis/setCategoriasDeposito");
    this.$store.dispatch("siis/setSubCategoriasDeposito");
    this.$store.dispatch("siis/setTipoDeposito");
    this.$store.dispatch("siis/setEstadosEfectoDeposito");
    this.$store.dispatch("siis/setEstadosSolicitudDeposito");
  },
  computed: {
    ...mapState({
      MarcaID: (state) => state.siis.marca,
      ModeloID: (state) => state.siis.modelo,
      categorias: (state) => state.siis.categoriasDeposito,
      subcategorias: (state) => state.siis.subcategoriasDeposito,
      tipo: (state) => state.siis.tipoDeposito,
      estadosEfectoDeposito: (state) => state.siis.estadosEfectoDeposito,
    }),
    ...mapGetters('sumario/robados', [
      'robadosList',
      'robadosTodos',
      'robadosCount',
      'getRobadoByArrId',
      'getNewRobadoArrId',
      'robadosTodosSelect'
    ]),
    robadosListFormatted() {
      return this.robadosList.map(r => ({
        arrId: r.doc.ActuacionEfectoID,
        name: r.doc.Tipoefecto || 'Sin nombre',
        doc: r.doc
      }));
    },
    dataArrId: {
      get() {
        return this.arrId;
      },
      set(value) {
        this.arrId = value;
      },
    },
    dataCategoria:{
      get(){
        if (!this.efectoData || !this.efectoData.CategoriaID) return 'Sin Datos';
        const categoria = this.categorias.find((c) => c.CategoriaID == this.efectoData.CategoriaID) 
        return categoria?.Nombre || 'Sin Datos';
      }
    },
    dataSubCategoria:{
      get(){
        if (!this.efectoData || !this.efectoData.SubcategoriaID) return 'Sin Datos';
        const subCategoria = this.subcategorias.find((s) => s.SubcategoriaID == this.efectoData.SubcategoriaID) 
        return subCategoria?.Nombre || 'Sin Datos';
      }
    },
    dataTipo:{
      get(){
        if (!this.efectoData || !this.efectoData.TipoID) return 'Sin Datos';
        const tipo = this.tipo.find((t) => t.tipoID == this.efectoData.TipoID) 
        return tipo?.nombre || 'Sin Datos';
      }
    },
    dataMarca:{
      get(){
        if (!this.efectoData || !this.efectoData.MarcaID) return 'Sin Datos';
        const marca = this.MarcaID.find((m) => m.MarcaID == this.efectoData.MarcaID) 
        return marca?.nombre || 'Sin Datos';
      }
    },
    dataModelo:{
      get(){
        if (!this.efectoData || !this.efectoData.ModeloID) return 'Sin Datos';
        const modelo = this.ModeloID.find((m) => m.ModeloID == this.efectoData.ModeloID) 
        return modelo?.Nombre || 'Sin Datos';
      }
    }
  },
  watch: {
    dataArrId(newVal) {
      const efecto = this.robadosList.find(r => r.doc.ActuacionEfectoID === newVal);
      this.efectoData = efecto ? efecto.doc : {};
    }
  },

  methods: {
    getSubcategoriaName(subCategoriaID){
      const subCategoria = this.subcategorias.find((s) => s.SubcategoriaID == subCategoriaID) 
      return subCategoria?.Nombre || 'Datos Incompletos';
    },
  }
}
</script>
<style scoped>

</style>